import {Table} from 'antd';
import {toUtcDateStringShort} from "../../util/timeutils";

export const TaskNotesTable = ({notes, props}) => {
    const columns = [
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: 'Author',
            dataIndex: 'firstname',
            key: 'author',
            render: (val, record, index) => {
                return `${record.firstname} ${record.lastname}`;
            }
        },
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                return toUtcDateStringShort(new Date(val))
            }
        },
    ];

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    return <Table dataSource={notes} columns={columns} pagination={tablePagination} />
}